import React, { useEffect } from 'react';

// props

// components
import { DefaultButton, IContextualMenuItem } from '@fluentui/react';
import FilterPanel, { FilterOptionProps } from '../../../uiframeworks/filters/panel';
import DateFilterPanel from '../../../uiframeworks/filters/panels/date';

interface IOfferListFilterButtonProps {
    selected: FilterOptionProps[];
    onChange(selected: FilterOptionProps[]): void;
}

const OfferListFilterButton: React.FC<IOfferListFilterButtonProps> = (props: IOfferListFilterButtonProps) => {
    const [activeSurface, setActiveSurface] = React.useState<string | undefined>();
    const [selected, setSelected] = React.useState<FilterOptionProps[]>(props.selected);

    useEffect(() => {
        setSelected(props.selected);
    }, [props.selected]);

    const _onFilterApplied = (_selected: FilterOptionProps[]) => {
        props.onChange(_selected);
        setActiveSurface(undefined);
    }

    const _onCancelled = () => {
        setActiveSurface(undefined);
    }

    const renderFilterButton = () => {
        const items: IContextualMenuItem[] = [
            {
                key: 'date',
                text: 'By date',
                onClick: () => {
                    setActiveSurface('date_filter');
                }
            }
        ];

        return <DefaultButton menuIconProps={{ iconName: "Filter" }} text={"Filter"} menuProps={{ items }} />;
    }

    return <>
        {renderFilterButton()}
        {activeSurface === 'date_filter' ? <>
            <DateFilterPanel title={"Filter by Date"}
                selected={selected}
                onCancel={_onCancelled}
                onApply={_onFilterApplied} />
        </> : null}
    </>;
};

export default OfferListFilterButton;
